var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageSquares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 473,
    viewBox: "0 0 579 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.1 27.8304L256 18.659V0L271.1 9.17137V27.8304Z",
    fill: "#C0162E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M578.1 268.184L563 259.012V240.353L578.1 249.525V268.184Z",
    fill: "#C0162E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.1 472.695L346 463.523V444.864L361.1 454.036V472.695Z",
    fill: "#C0162E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 286.737L0 280.484V267.762L10 274.015V286.737Z",
    fill: "#59595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageSquares);
export default __webpack_public_path__ + "static/media/homepage_squares.f6d290d36bb65a9e8bd50bc3e9a0fffc.svg";
export { ForwardRef as ReactComponent };